//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUpload from '@/components/file-upload'
import DivSpan from '@/components/DivSpan'
export default {
  components:{fileUpload,DivSpan},
  props:['supSupplyCatList'],
  methods:{
    changeShow(i){
      if(this.supQualList[i].cellShow){
        this.$set(this.supQualList[i],'cellShow',false);
        return;
      }
      this.$set(this.supQualList[i],'cellShow',true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier/view/supply-category.vue